import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../auth/supabase";

const WishlistAuthPopup = ({ onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate("/login");
  };

  const handleGuest = async () => {
    try {
      const { error } = await supabase.auth.signInAnonymously();

      if (error) {
        console.error("Anonymous sign-in failed:", error);
        alert(error.message || "Unable to continue as guest.");
        return;
      }

      onClose();
    } catch (error) {
      console.error("Guest authentication failed:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 font-poppins"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm sm:max-w-md rounded-2xl sm:rounded-3xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 p-5 sm:p-8 shadow-2xl animate-[fadeInUp_0.3s_ease]"
        onClick={(e) => e.stopPropagation()}
      >
        <style>{`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(12px) scale(0.98); }
            to { opacity: 1; transform: translateY(0) scale(1); }
          }
        `}</style>

        {/* Close button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 sm:right-4 sm:top-4 flex h-8 w-8 items-center justify-center rounded-full text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
          aria-label="Close"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Icon */}
        <div className="mb-5 sm:mb-6 flex justify-center">
          <div className="flex h-16 w-16 sm:h-[72px] sm:w-[72px] items-center justify-center rounded-full bg-blue-50 dark:bg-blue-500/10 ring-1 ring-[#2563EB]/15">
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              className="text-[#2563EB] sm:w-8 sm:h-8"
              fill="currentColor"
            >
              <path d="M12 21s-6.716-4.35-9.428-8.303C.94 10.244 1.02 6.9 3.343 4.9a5.5 5.5 0 017.657.31L12 6.22l1-1.01a5.5 5.5 0 017.657-.31c2.323 2 2.404 5.344.771 7.797C18.716 16.65 12 21 12 21z" />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
            Save your favourites
          </h2>

          <p className="mt-2.5 sm:mt-3 text-sm leading-6 text-gray-500 dark:text-gray-400">
            Sign in to save products to your wishlist and easily find them
            whenever you need them.
          </p>
        </div>

        {/* Actions — stacked on mobile, same row on desktop */}
        <div className="mt-6 sm:mt-7 flex flex-col sm:flex-row items-stretch gap-2.5 sm:gap-3">
          <button
            type="button"
            onClick={handleGuest}
            className="flex-1 whitespace-nowrap rounded-xl border border-gray-200 dark:border-gray-600 px-4 py-3 text-sm sm:text-base font-semibold text-gray-700 dark:text-gray-200 transition-colors hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            Continue as Guest
          </button>

          <button
            type="button"
            onClick={handleLogin}
            className="flex-1 whitespace-nowrap rounded-xl bg-[#2563EB] px-4 py-3 text-sm sm:text-base font-semibold text-white shadow-md shadow-[#2563EB]/25 transition-colors hover:bg-[#1d4ed8]"
          >
            Sign in
          </button>
        </div>

        <p className="mt-4 text-center text-xs text-gray-400 dark:text-gray-500">
          You can continue browsing without signing in.
        </p>
      </div>
    </div>
  );
};

export default WishlistAuthPopup;